{
  "time": "Time",
  "startTime": "Start time",
  "endTime": "End time"
}
